/**
 * Wordmark — do.place brand mark + wordmark (staging.do.place identity,
 * adopted 2026-07-23).
 *
 * Renders the "D dock" mark inline (SVG, `currentColor` frame + gold→red
 * gradient "o") followed by the wordmark in JetBrains Mono 700. Inline SVG
 * (not <img>) so the frame picks up the surrounding nav colour and no
 * font-loading applies inside the asset. Gradient/mask ids are namespaced
 * via useId so multiple instances (desktop + mobile nav) don't collide.
 */

import { useId } from 'react';
import { useConfig } from '../config/ConfigContext';

export default function Wordmark() {
  const config = useConfig();
  const uid = useId();
  const gradId = `dp-mark-grad-${uid}`;
  const maskId = `dp-mark-mask-${uid}`;

  return (
    <a
      href="/"
      aria-label={`${config.instance.name} — home`}
      style={{
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '9px',
        flexShrink: 0,
        color: 'var(--fg-on-navy)',
        fontFamily: 'var(--font-mono)',
        fontWeight: 700,
        fontSize: '17px',
        letterSpacing: '-0.02em',
      }}
    >
      <svg width="22" height="22" viewBox="0 0 72 72" aria-hidden="true" style={{ display: 'block', flexShrink: 0 }}>
        <defs>
          <linearGradient id={gradId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stopColor="#F4B740" />
            <stop offset="1" stopColor="#E4483A" />
          </linearGradient>
          <mask id={maskId}>
            <rect x="-4" y="-12" width="84" height="90" fill="#fff" />
            <circle cx="55" cy="50" r="20" fill="#000" />
          </mask>
        </defs>
        <path
          d="M20 10 L26 10 A26 26 0 0 1 52 36 A26 26 0 0 1 26 62 L20 62 A6 6 0 0 1 14 56 L14 16 A6 6 0 0 1 20 10 Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="7"
          mask={`url(#${maskId})`}
        />
        <circle cx="55" cy="50" r="12" fill="none" stroke={`url(#${gradId})`} strokeWidth="7" />
      </svg>
      do.place
    </a>
  );
}
